import { ID, IPost, LIKE_TYPE } from "../interfaces/layouts";

/*
 *   fake post. Expand as needed.
 */
export default function postMock(__typename: string="Post"): IPost {
    return {
        id:1 as ID, 
        title: "Post title",
        post_content: "Post content",
        order: 1,
        comments: [],
        attachments: [],
        bookmarks: [
            {id:2, display_name: "Petronius", avatar: "/assets/img/administrators-icon.png", roles:[],},
            {id:3, display_name: "Albert", avatar: "/assets/img/user_ava.png", roles:[],},
        ],
        images:[],
        likes: [
            {
                user: {id:2, display_name: "Petronius", avatar: "/assets/img/administrators-icon.png", roles:[],},
                type: LIKE_TYPE.LIKE,
            },
            {
                user: {id:3, display_name: "Albert", avatar: "/assets/img/user_ava.png", roles:[],},
                type: LIKE_TYPE.LIKE,
            },
            {
                user: {id:4, display_name: "Bandos", avatar: "/assets/img/user_ava.png", roles:[],},
                type: LIKE_TYPE.LIKE,
            },
        ],
        __typename
    } as IPost
}